import { useState } from 'react';
import { useHistory } from 'react-router';
import { searchPathByKeyword } from '../../../utils/urlHelpers/boats';
import { definedValue } from '../../../utils';

const getPlaceholder = (placeholderTxt, match) => {
  if (match?.params?.keyword) {
    return definedValue(match.params.keyword.split('-')[1], '');
  }
  return definedValue(placeholderTxt, '');
};

const useHeaderSearch = (searchTitle,  notFoundText, match) => {
  const [searchValue, setSearchValue] = useState('');

  const history = useHistory();
  // when we deal with predictive search, we will need to pass the options
  const options = [];

  const onKeyUp = (e) => {
    if (e.key === 'Enter') {
      gotoKeywordPage();
      return;
    }
    setSearchValue(e.target.value);
  };

  const gotoKeywordPage = () => {
    if (definedValue(searchValue, '').trim() === '') {
      return;
    }

    const event = new CustomEvent('keywordSearchExecuted', {
      detail: {
        newKeywordSearch: searchValue.trim()
      }
    });
    window.dispatchEvent(event);

    const newUrl = searchPathByKeyword(searchValue);
    history.push(newUrl);
  };

  const onSubmitSearch = (e) => {
    e.preventDefault();
  };

  const onSearchChange = () => {
    gotoKeywordPage();
  };

  const searchPlaceholder = getPlaceholder(searchTitle, match);

  const searchBox = {
    searchPlaceholder: searchPlaceholder,
    placeholder: searchTitle,
    bgPlaceholder: searchPlaceholder,
    emptyPlaceholder: searchPlaceholder,
    hideSuggestions: true,
    notFoundText,
    onSearchChange,
    options,
    onKeyUp
  };
  return { searchBox, onSubmitSearch, searchValue };
};

export { useHeaderSearch };
